import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToasterService } from '../../services/toaster/toaster.service';

@Component({
  selector: 'app-transaction-success',
  templateUrl: './transaction-success.component.html',
  styleUrls: ['./transaction-success.component.sass']
})
export class TransactionSuccessComponent implements OnInit {
  
  constructor(
    private router: Router,
    private toasterService: ToasterService
  ) { }

  ngOnInit(): void {
    // Show success message
    this.toasterService.show('success', 'Payment successful! Your subscription has been activated.');
  }

  /**
   * Navigate to the billing page
   */
  goToBilling(): void {
    this.router.navigate(['/billing']);
  }

  /**
   * Navigate to the dashboard
   */
  goToDashboard(): void {
    this.router.navigate(['/dashboard']);
  }
}